export const appRoutesNames = {
  PROFILE: 'profile',
  CANDIDATURES: 'candidatures',
  TESTS : 'tests',
  LOGIN : 'login',
  QUESTIONSLIBRARY : 'categories',
  USERS: 'users',
  DETAILSCANDIDATURE: 'details'
}
